import { toRefs, computed } from 'vue';
import tinycolor from 'tinycolor2';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm.js';

//
var script = {
  name: 'FancyIconCircle',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: '1.5rem'
    },
    /* How large should the circle be in relation to the size of the icon */
    multiplier: {
      type: Number,
      default: 2.5
    }
  },
  setup(props) {
    const {
      color,
      size,
      multiplier
    } = toRefs(props);
    const theme = useTheme();
    const styles = computed(() => {
      const iconColor = getThemeColor(color.value, theme.value);
      return {
        '--c-bg-color': tinycolor(iconColor).setAlpha(0.05),
        '--c-color': iconColor,
        '--c-font-size': size.value,
        '--c-multiplier': multiplier.value
      };
    });
    return {
      styles
    };
  }
};
export { script as default };